function setSessionForMenu(e) {
    window.sessionStorage.setItem("currentSiteMenu", `${e}`);
}
function applyHover(e, t, l, n, i) {
    var a = t.querySelector(l);
    a && (a.style.color = i), n ? t && (t.style.background = e) : t && (t.classList.contains("active") ? (t.style.background = e) : (t.style.background = "transparent"));
}
let debounceTimer;
function handleSlideNav(e, t) {
    t.preventDefault();
    try {
        let l = t.currentTarget,
            n = parseInt(l.getAttribute("data-slide")),
            i = l.getAttribute("data-disabled");
        if ("true" == i) return;
        clearTimeout(debounceTimer),
            (debounceTimer = setTimeout(() => {
                let t = l.offsetParent,
                    i = (t = t.querySelector(".shoppable-blog__slider")).childNodes.length,
                    a = t.offsetWidth,
                    s;
                switch (e) {
                    case "prev":
                        (s = l.nextElementSibling),
                            n - 1 == 1 && l.setAttribute("data-disabled", "true"),
                            s.setAttribute("data-disabled", "false"),
                            s.setAttribute("data-slide", n - 1),
                            l.setAttribute("data-slide", n - 1),
                            t.scrollBy({ top: 0, left: -a, behavior: "smooth" });
                        break;
                    case "next":
                        (s = l.previousElementSibling),
                            n + 1 == i && l.setAttribute("data-disabled", "true"),
                            s.setAttribute("data-disabled", "false"),
                            s.setAttribute("data-slide", n + 1),
                            l.setAttribute("data-slide", n + 1),
                            t.scrollBy({ top: 0, left: +a, behavior: "smooth" });
                }
            }, 400));
    } catch (a) { }
}
!(function () {
    !(function e() {
        var t = document.querySelector(".delivery-expendite");
        if (t) {
            var l = t.dataset.expendite,
                n = 10,
                i = 15;
            "BUSAN" == l ? ((n = 4), (i = 8)) : "USA" == l && ((n = 5), (i = 8));
            var a = new Date(),
                s = new Date();
            a.setDate(a.getDate() + n), s.setDate(s.getDate() + i);
            var r = a.toLocaleString("en-US", { month: "long" }),
                o = a.getFullYear(),
                d = a.getDate(),
                c = s.toLocaleString("en-US", { month: "long" }),
                u = s.getFullYear(),
                y = s.getDate(),
                v = "";
            o != u && (v = " " + o), console.log(d, y, r, c), (t.innerHTML += "<span class='dl-label'>Expected delivery by</span><span class='dl-date'> " + r + " " + d + v + " - " + c + " " + y + ", " + u + "</span>");
        }
    })(),
        document.querySelectorAll(".sale-countdown").forEach(function (e) {
            var t = 1e3 * e.dataset.saleEndDate;
            function l() {
                var l = t - new Date().getTime();
                (e.innerHTML =
                    "<div class='sale-countdown-header'><span class='sale-countdown-title'>TIMEDEAL</span><span class='sale-countdown-subtitle'>ENDS IN</span></div><ul><li><div class='sale-countdown-number'>" +
                    Math.floor(l / 864e5).toString().padStart(2, '0') +
                    "</div><div class='sale-countdown-time'>Days</div></li><li><div class='sale-countdown-number'>" +
                    Math.floor((l % 864e5) / 36e5).toString().padStart(2, '0') +
                    "</div><div class='sale-countdown-time'>Hours</div></li><li><div class='sale-countdown-number'>" +
                    Math.floor((l % 36e5) / 6e4).toString().padStart(2, '0') +
                    "</div><div class='sale-countdown-time'>Minutes</div></li></ul>"),
                    l < 0 && (clearInterval(e.timerInterval), (e.innerHTML = ""));
            }
            t && "" !== t && (l(), (e.timerInterval = setInterval(l, 1e3)));
        });
    var e = document.getElementById("dlt-account");
    e &&
        e.addEventListener("click", function (e) {
            var t = e.currentTarget,
                l = e.currentTarget.offsetParent,
                n = l.querySelector(".delete-close"),
                i = l.querySelector(".btn--outline"),
                a = l.querySelector(".delete-content"),
                s = l.querySelector("h4"),
                [r, o] = t.children;
            (n.style.display = "none"),
                (i.style.display = "none"),
                (r.style.display = "block"),
                (o.style.display = "none"),
                (s.innerHTML = "Requesting for deleting the account!"),
                fetch("https://dodoskin-dashboard.vercel.app/api/v1/shopify/delete", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ customerId: Number(t.dataset.id), value: !0 }) })
                    .then((e) => e.json())
                    .then((e) => {
                        (n.style.display = "block"),
                            (i.style.display = "block"),
                            (r.style.display = "none"),
                            (o.style.display = "block"),
                            (s.innerHTML = "Are you absolutely sure?"),
                            (a.innerHTML = "This action cannot be undone. This will permanently delete your account and remove your data from the store."),
                            (location.href = "/account");
                    })
                    .catch((e) => {
                        (n.style.display = "block"),
                            (i.style.display = "block"),
                            (r.style.display = "none"),
                            (o.style.display = "block"),
                            (s.innerHTML = "Oops! something went wrong."),
                            (a.innerHTML = "Something went wrong while requesting the deletion of your account.");
                    });
        }),
        document.querySelectorAll(".nav-link"),
        window.location.pathname;
    var t = document.getElementById("shop"),
        l = document.getElementById("sheet-modal"),
        n = document.getElementById("sheet-overlay");

    // Add null check to prevent error
    if (t) {
        t.addEventListener("click", function () {
            var e = document.getElementById("mobile-menu-left-drawer");
            e &&
                requestAnimationFrame(function () {
                    e.click();
                });
        });
    }

    if (n) {
        n.addEventListener("click", function () {
            l.classList.remove("open"), n.classList.remove("visible");
        });
    }

    var i = document.querySelector(".jdgm-rev-widg__title");
    if (i) {
        var a = document.createElement("p");
        (a.innerText = "Join the Discussion"), a.classList.add("review-desc"), i.after(a);
    }
    let s = document.querySelectorAll(".custom-links-section");
    s &&
        s.forEach(function (e) {
            let t = e.querySelector(".toggle-links"),
                l = e.querySelector(".links-container"),
                n = t.querySelector(".chevron-down-link"),
                i = t.querySelector(".chevron-up-link");
            t.addEventListener("click", function () {
                l.classList.contains("expanded") ? (l.classList.remove("expanded"), (i.style.display = "none"), (n.style.display = "block")) : (l.classList.add("expanded"), (i.style.display = "block"), (n.style.display = "none"));
            });
        });
    let accesibilityLink = document.querySelector("#accesibility-link");
    accesibilityLink && accesibilityLink.addEventListener("click", function () {
        var accessiblyAppDialogButton = document.querySelector("#accessiblyAppDialogButton");
        if (typeof accessiblyAppDialogButton != "undefined") {
            accessiblyAppDialogButton.click();
        }
    });
})();

// Function to hide elements when shadowRoot is available
function hideChatElements() {
    const shadowRoot = document.querySelector("#ShopifyChat")?.shadowRoot || null;

    if (shadowRoot) {
        // Create a new <style> element to append custom styles
        const style = document.createElement('style');
        style.innerHTML = `
      .return-to-chat-wrapper { display: none !important; }
      .composer-bar-form, .composer-bar-chatView, .message-prompt { display: none !important; }
      .message-container{padding-bottom:10px;}
      /* You can add more custom styles here */
    `;

        // Append the style element to the shadowRoot
        shadowRoot.appendChild(style);
    }
}

// Observer to check if #ShopifyChat is added to the DOM
const observer = new MutationObserver((mutations, obs) => {
    const shopifyChat = document.querySelector("#ShopifyChat");
    if (shopifyChat) {
        obs.disconnect(); // Stop observing once element is found
        hideChatElements()

    }
});

// Start observing the body for changes
observer.observe(document.body, { childList: true, subtree: true });

// =====================================
// Mobile Filter Slide Navigation
// =====================================

// Global function to open a filter panel
function openFilterPanel(btn, panelId) {
    var nav = btn.closest('[data-mobile-filter-nav]');
    if (!nav) return;

    var main = nav.querySelector('[data-filter-panel="main"]');
    var target = nav.querySelector('[data-filter-panel="' + panelId + '"]');

    if (target && main) {
        main.classList.add('is-sliding-out');
        main.classList.remove('is-active');
        target.classList.add('is-active');
    }
}

// Global function to go back to main panel
function goBackToMainPanel(btn) {
    var nav = btn.closest('[data-mobile-filter-nav]');
    if (!nav) return;

    var main = nav.querySelector('[data-filter-panel="main"]');
    var detail = btn.closest('.mobile-filter-nav__panel--detail');

    if (detail && main) {
        detail.classList.remove('is-active');
        main.classList.remove('is-sliding-out');
        main.classList.add('is-active');
    }
}

(function () {
    'use strict';

    // Stop propagation on all filter option clicks using capture phase
    document.addEventListener('click', function (e) {
        // Check if click is on or inside a filter option (checkbox area)
        var option = e.target.closest('.mobile-filter-nav__option');
        var checkbox = e.target.closest('.mobile-filter-nav__checkbox');
        var input = e.target.closest('.mobile-filter-nav__input');

        // Desktop check
        var desktopButton = e.target.closest('.filter__button');
        var desktopInput = e.target.closest('.filter__input');

        if (option || checkbox || input || desktopButton || desktopInput) {
            e.stopPropagation();
            // Don't return - let the click continue to toggle the checkbox
        }
    }, true); // Use capture phase

    // Handle checkbox changes to trigger filter form submission
    document.addEventListener('change', function (e) {
        if (e.target.classList.contains('mobile-filter-nav__input') || e.target.classList.contains('filter__input')) {
            e.stopPropagation();
            // Find the filters form and trigger input event for AJAX filtering
            var filtersForm = document.querySelector('[data-collection-filters-form]');
            if (filtersForm) {
                filtersForm.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    }, true); // Use capture phase

    // Use document-level event delegation for navigation (bubbling phase)
    document.addEventListener('click', function (e) {
        // Skip if click originated from a filter option
        if (e.target.closest('.mobile-filter-nav__option') ||
            e.target.closest('.mobile-filter-nav__checkbox')) {
            return;
        }

        // Only process if we're in a mobile filter nav context
        var mobileFilterNav = e.target.closest('[data-mobile-filter-nav]');
        if (!mobileFilterNav) return;

        var mainPanel = mobileFilterNav.querySelector('[data-filter-panel="main"]');
        var panels = mobileFilterNav.querySelectorAll('[data-filter-panel]');

        // Handle filter category trigger clicks
        var trigger = e.target.closest('[data-filter-nav-trigger]');
        if (trigger) {
            e.preventDefault();
            e.stopPropagation();

            var targetPanelId = trigger.getAttribute('data-target-panel');
            var targetPanel = mobileFilterNav.querySelector('[data-filter-panel="' + targetPanelId + '"]');

            if (targetPanel && mainPanel) {
                mainPanel.classList.add('is-sliding-out');
                mainPanel.classList.remove('is-active');
                targetPanel.classList.add('is-active');
            }
            return;
        }

        // Handle back button clicks
        var backBtn = e.target.closest('[data-filter-nav-back]');
        if (backBtn) {
            e.preventDefault();
            e.stopPropagation();

            var activeDetailPanel = mobileFilterNav.querySelector('.mobile-filter-nav__panel--detail.is-active');

            if (activeDetailPanel && mainPanel) {
                activeDetailPanel.classList.remove('is-active');
                mainPanel.classList.remove('is-sliding-out');
                mainPanel.classList.add('is-active');
            }
            return;
        }

        // Handle close button clicks - reset panels
        var closeBtn = e.target.closest('[data-close-filters]');
        if (closeBtn) {
            setTimeout(function () {
                panels.forEach(function (panel) {
                    if (panel.getAttribute('data-filter-panel') === 'main') {
                        panel.classList.add('is-active');
                        panel.classList.remove('is-sliding-out');
                    } else {
                        panel.classList.remove('is-active');
                    }
                });
            }, 300);
        }
    });
})();

// =====================================
// Mobile Filters Toggle
// =====================================
(function () {
    'use strict';

    // Add click listener to mobile filter button
    document.addEventListener('click', function (e) {

        var mobileFilterBtn = e.target.closest('.collection-filters.mobile-filters');

        if (mobileFilterBtn) {

            var filterPanel = document.querySelector('.collection__filters[data-collection-filters]');

            if (filterPanel) {
                filterPanel.classList.add('collection__filters--visible');
            } else {
                console.log('ERROR: Filter panel not found!');
            }
        }
    });
})();

document.addEventListener('DOMContentLoaded', () => {
    // Function to sync text from Desktop (Source) to Mobile (Target)
    const syncFilterText = () => {
        // Specific selector for the Desktop filters title (Source)
        const sourceEl = document.querySelector('.collection-filters.desktop-filters .collection__filters__title span');
        // Specific selector for the Mobile filters title (Target)
        const targetEl = document.querySelector('.collection-filters.mobile-filters .collection__filters__title span');

        if (!sourceEl || !targetEl) return;

        if (targetEl.textContent !== sourceEl.textContent) {
            console.log('Syncing Filter Text:', {
                from: sourceEl.textContent,
                to: targetEl.textContent
            });
            targetEl.textContent = sourceEl.textContent;
        }
    };

    // Initial sync
    syncFilterText();

    // Observe document body for any changes that might affect filters (AJAX loading, text changes)
    const observer = new MutationObserver((mutations) => {
        let shouldSync = false;

        for (const mutation of mutations) {
            if (mutation.type === 'childList') {
                // Check if relevant elements were added to DOM
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1) { // Element
                        if (node.matches && (
                            node.querySelector('.collection-filters') ||
                            node.matches('.collection-filters') ||
                            node.classList.contains('collection__filters__title')
                        )) {
                            shouldSync = true;
                            break;
                        }
                    }
                }
            } else if (mutation.type === 'characterData') {
                // Check if text content inside title changed
                const parent = mutation.target.parentElement;
                if (parent && parent.closest('.collection__filters__title')) {
                    shouldSync = true;
                }
            }
        }

        if (shouldSync) {
            setTimeout(syncFilterText, 50); // Small delay to ensure DOM is ready
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
    });
});

// =====================================
// Applied Filters Synchronization (Desktop <-> Mobile)
// =====================================
(function () {
    'use strict';

    let appliedFiltersObserver = null;

    function initAppliedFiltersSync() {
        const desktopContainer = document.querySelector('.collection-applied__filters:not(.collection-applied__filters-mobile)');
        const mobileContainer = document.querySelector('.collection-applied__filters.collection-applied__filters-mobile');

        if (!desktopContainer || !mobileContainer) return;

        // Function to sync content from desktop to mobile
        const syncContent = () => {
            // Check if content is actually different to avoid unnecessary DOM updates
            if (mobileContainer.innerHTML !== desktopContainer.innerHTML) {
                mobileContainer.innerHTML = desktopContainer.innerHTML;
            }

            // Toggle visibility based on content
            const hasFilters = desktopContainer.children.length > 0;
            mobileContainer.classList.toggle('is-visible', hasFilters);
            mobileContainer.style.display = hasFilters ? 'flex' : 'none';
        };

        // Initial sync
        syncContent();

        // Disconnect previous observer if any
        if (appliedFiltersObserver) {
            appliedFiltersObserver.disconnect();
        }

        // MutationObserver to watch for changes in desktop container
        appliedFiltersObserver = new MutationObserver(() => {
            syncContent();
        });

        appliedFiltersObserver.observe(desktopContainer, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }

    // Global event delegation for mobile filter interaction sync
    document.addEventListener('click', function (e) {
        const mobileContainer = e.target.closest('.collection-applied__filters.collection-applied__filters-mobile');
        if (!mobileContainer) return;

        const target = e.target.closest('[data-filter-reset-button], .filter__active__remove, .collection-applied__clear-all');
        if (target) {
            e.preventDefault();
            e.stopPropagation();

            const desktopContainer = document.querySelector('.collection-applied__filters:not(.collection-applied__filters-mobile)');
            if (!desktopContainer) return;

            // Find index of clicked element in mobile
            const mobileTargets = Array.from(mobileContainer.querySelectorAll('[data-filter-reset-button], .filter__active__remove, .collection-applied__clear-all'));
            const index = mobileTargets.indexOf(target);

            // Find corresponding element in desktop
            const desktopTargets = Array.from(desktopContainer.querySelectorAll('[data-filter-reset-button], .filter__active__remove, .collection-applied__clear-all'));

            if (desktopTargets[index]) {
                // Trigger click on desktop counterpart to reuse existing logic
                desktopTargets[index].click();
            }
        }
    });

    // Initial setup
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAppliedFiltersSync);
    } else {
        initAppliedFiltersSync();
    }

    // Handle AJAX reloads by observing a higher-level container
    const collectionWrapper = document.querySelector('[data-collection-wrapper]') || document.body;
    const wrapperObserver = new MutationObserver((mutations) => {
        let shouldReinit = false;
        for (const mutation of mutations) {
            if (mutation.type === 'childList') {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1 && (node.matches('.collection-applied__filters') || node.querySelector('.collection-applied__filters'))) {
                        shouldReinit = true;
                        break;
                    }
                }
            }
            if (shouldReinit) break;
        }
        if (shouldReinit) {
            initAppliedFiltersSync();
        }
    });

    wrapperObserver.observe(collectionWrapper, { childList: true, subtree: true });
})();

// =====================================
// Auto-Close Filter Drawer on Outside Click
// =====================================
(function () {
    'use strict';

    // Handle document-level clicks to close filter drawers when clicking outside
    document.addEventListener('click', function (e) {
        const sortingDrawer = document.getElementById('CollectionSorting');
        const expandedFilters = document.querySelectorAll('.collection__filter-tags-wrapper.is-expanded');

        // Check if any drawer is actually open
        const isSortOpen = sortingDrawer && (sortingDrawer.classList.contains('is-visible') || sortingDrawer.classList.contains('collection__sort__option-wrapper--visible'));
        if (expandedFilters.length === 0 && !isSortOpen) return;

        const filterToggle = e.target.closest('[data-collapsible-trigger]');
        const sortToggle = e.target.closest('[data-sort-toggle]');

        // 1. If clicking a toggle button, close OTHER types of drawers
        if (filterToggle || sortToggle) {
            if (filterToggle) {
                // If opening a filter, close sort
                if (sortingDrawer) {
                    sortingDrawer.classList.remove('is-visible', 'collection__sort__option-wrapper--visible');
                    const sortBtn = document.querySelector('[data-sort-toggle]');
                    if (sortBtn) sortBtn.classList.remove('is-expanded');
                }
                // Also close other expanded filters
                expandedFilters.forEach(function (drawer) {
                    const buttonForThisDrawer = document.querySelector('[aria-controls="' + drawer.id + '"]');
                    if (buttonForThisDrawer && buttonForThisDrawer !== filterToggle) {
                        drawer.classList.remove('is-expanded');
                        drawer.setAttribute('aria-expanded', 'false');
                        buttonForThisDrawer.classList.remove('is-expanded');
                        buttonForThisDrawer.setAttribute('aria-expanded', 'false');
                    }
                });
            }
            if (sortToggle) {
                // If opening sort, close all filters
                expandedFilters.forEach(function (drawer) {
                    drawer.classList.remove('is-expanded');
                    drawer.setAttribute('aria-expanded', 'false');
                    const button = document.querySelector('[aria-controls="' + drawer.id + '"]');
                    if (button) {
                        button.classList.remove('is-expanded');
                        button.setAttribute('aria-expanded', 'false');
                    }
                });
            }
            return;
        }

        // 2. Handle outside clicks
        let clickedInsideAnyDrawer = false;
        if (sortingDrawer && sortingDrawer.contains(e.target)) clickedInsideAnyDrawer = true;
        expandedFilters.forEach(drawer => { if (drawer.contains(e.target)) clickedInsideAnyDrawer = true; });

        if (!clickedInsideAnyDrawer) {
            // Close filters
            expandedFilters.forEach(function (drawer) {
                const button = document.querySelector('[aria-controls="' + drawer.id + '"]');
                drawer.classList.remove('is-expanded');
                drawer.setAttribute('aria-expanded', 'false');
                if (button) {
                    button.classList.remove('is-expanded');
                    button.setAttribute('aria-expanded', 'false');
                }
            });

            // Close sort
            if (sortingDrawer) {
                sortingDrawer.classList.remove('is-visible', 'collection__sort__option-wrapper--visible');
                const sortBtn = document.querySelector('[data-sort-toggle]');
                if (sortBtn) {
                    sortBtn.classList.remove('is-expanded');
                    sortBtn.setAttribute('aria-expanded', 'false');
                }
            }
        }
    });
})();


